import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import styled from 'styled-components';
import CS from '@/styles/componentStyled';
import { Facilities } from '@/sdk/data-contracts';
import {
  dashboardFacilityRecoil,
  dashboardRegionRecoil,
} from '@/atom/DashboardAtom';
import { SimpleSouthKoreaMapChart } from 'react-simple-south-korea-map-chart';

export interface Regions {
  name: string;
  facilityCount: number;
  deviceCount: number;
  errorDeviceCount: number;
  communicationErrorCount: number;
  locale?: string;
  count?: number;
}

const TabArea = () => {
  const dashboardFacilityState = useRecoilValue(dashboardFacilityRecoil);
  const dashboardRegionState = useRecoilValue(dashboardRegionRecoil);

  const [regions, setRegions] = useState<Regions[]>([]);

  const setColorByCount = (count: number) => {
    if (count === 0) return '#F1F1F1';
    if (count > 5000) return '#79D3C4';
    if (count > 3000) return '#43cdb6';
    if (count > 1000) return '#61CDBB';
    if (count > 200) return '#91D9CD';
    if (count > 100) return '#A9DFD6';
    if (count > 50) return '#C1E5DF';
    if (count > 5) return '#D9EBE8';
    else return '#ebfffd';
  };

  useEffect(() => {
    if (dashboardRegionState) {
      const updatedRegions = dashboardRegionState?.regions.map((region) => {
        if (region.name === '부산' || region.name === '부산광역시') {
          return {
            ...region,
            locale: '부산광역시',
            count: region.deviceCount,
          };
        } else if (region.name === '대구' || region.name === '대구광역시') {
          return {
            ...region,
            locale: '대구광역시',
            count: region.deviceCount,
          };
        } else if (region.name === '대전' || region.name === '대전광역시') {
          return {
            ...region,
            locale: '대전광역시',
            count: region.deviceCount,
          };
        } else if (
          region.name === '강원특별자치도' ||
          region.name === '강원도'
        ) {
          return {
            ...region,
            locale: '강원도',
            count: region.deviceCount,
          };
        } else if (region.name === '광주' || region.name === '광주광역시') {
          return {
            ...region,
            locale: '광주광역시',
            count: region.deviceCount,
          };
        } else if (region.name === '경기' || region.name === '경기도') {
          return {
            ...region,
            locale: '경기도',
            count: region.deviceCount,
          };
        } else if (region.name === '인천' || region.name === '인천광역시') {
          return {
            ...region,
            locale: '인천광역시',
            count: region.deviceCount,
          };
        } else if (region.name === '제주특별자치도') {
          return {
            ...region,
            locale: '제주특별자치도',
            count: region.deviceCount,
          };
        } else if (region.name === '충북' || region.name === '충청북도') {
          return {
            ...region,
            locale: '충청북도',
            count: region.deviceCount,
          };
        } else if (region.name === '경북' || region.name === '경상북도') {
          return {
            ...region,
            locale: '경상북도',
            count: region.deviceCount,
          };
        } else if (
          region.name === '전북특별자치도' ||
          region.name === '전라북도' ||
          region.name === '전북'
        ) {
          return {
            ...region,
            locale: '전라북도',
            count: region.deviceCount,
          };
        } else if (region.name === '세종특별자치시') {
          return {
            ...region,
            locale: '세종특별자치시',
            count: region.deviceCount,
          };
        } else if (region.name === '충남' || region.name === '충청남도') {
          return {
            ...region,
            locale: '충청남도',
            count: region.deviceCount,
          };
        } else if (region.name === '경남' || region.name === '경상남도') {
          return {
            ...region,
            locale: '경상남도',
            count: region.deviceCount,
          };
        } else if (region.name === '전남' || region.name === '전라남도') {
          return {
            ...region,
            locale: '전라남도',
            count: region.deviceCount,
          };
        } else if (region.name === '울산' || region.name === '울산광역시') {
          return {
            ...region,
            locale: '울산광역시',
            count: region.deviceCount,
          };
        } else if (region.name === '서울' || region.name === '서울특별시') {
          return {
            ...region,
            locale: '서울특별시',
            count: region.deviceCount,
          };
        }
        return region;
      });
      setRegions(updatedRegions);
    }
  }, [dashboardRegionState]);

  return (
    <>
      <TableBox>
        <table>
          <tbody>
            <tr>
              <th>지역</th>
              <td>전국</td>
              <th>디바이스</th>
              <td>{dashboardRegionState?.totalDevice.toLocaleString()}</td>
            </tr>
            <tr>
              <th>시설물 수</th>
              <td>
                {dashboardFacilityState?.facilities.length.toLocaleString()}
              </td>
              <th>이상 디바이스</th>
              <td>{dashboardRegionState?.errorDevice.toLocaleString()}</td>
            </tr>
            <tr>
              <th>통신 실패</th>
              <td colSpan={3}>
                {dashboardRegionState?.communicationError.toLocaleString()}
              </td>
            </tr>
          </tbody>
        </table>
      </TableBox>
      <SimpleSouthKoreaMapChartWrap>
        <SimpleSouthKoreaMapChart
          setColorByCount={setColorByCount}
          data={regions}
        />
      </SimpleSouthKoreaMapChartWrap>
    </>
  );
};

export default TabArea;

export const TableBox = styled(CS.TableType1_3)`
  width: 100%;
  min-height: 133px;
  max-height: 133px;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const SimpleSouthKoreaMapChartWrap = styled.div`
  height: calc(100vh - 440px);
  overflow: hidden;
  svg {
    height: 100%;
    overflow: hidden;
  }
`;
